import React, { useState, useEffect } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  InformationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useGetUserPaymentDetailsQuery} from "../../../../store/paymentDetails";
import RangeSlider from "../../../rangeSlider";

const CreditModify = ({
  setSelectedPaymentPlan,
  professionalInfoDetail,
  handleClose,
}) => {
  const [selectedPrice, setSelectedPrice] = useState("");
  const [bonusCredits, setBonusCredits] = useState(false);
  const { data: paymentDetails } = useGetUserPaymentDetailsQuery(professionalInfoDetail.regions?.[0].user_id);

  useEffect(() => {
    if (professionalInfoDetail?.paymentOption) {
      const { price, id } = professionalInfoDetail.paymentOption;
      const usersPrice = `$${price}`;

      localStorage.setItem("package_id", id);
      setSelectedPrice(usersPrice);
      setBonusCredits(Number(price) >= 1000);
    } else {
      if(paymentDetails?.length)
      {
      const defaultValue = paymentDetails[0]?.payment_options?.find((pack) => pack.is_default === 1);

      if (defaultValue) {
        const { price, id } = defaultValue;
        const defaultPrice = `$${price}`;

        setSelectedPrice(defaultPrice);
        setBonusCredits(Number(price) >= 1000);
        localStorage.setItem("package_id", id);

        const defaultPayment = paymentDetails[0]?.payment_options.find(
          (item) => Number(item.price) === Number(defaultPrice.replace("$", ""))
        );

        if (defaultPayment) {
          setSelectedPaymentPlan(defaultPayment);
        }
      }
    }
    }
  }, [paymentDetails]);

  let rangeItems = [];
  let leadItems = [];
  if (paymentDetails?.length) {
    paymentDetails[0]?.payment_options.map((item) => {
      rangeItems.push(`$${item.price}`);
    });
    paymentDetails[0]?.payment_options.map((item) => {
      // leadItems.push(`${item.additional_info}`);
      if(item.lead_range.type == 'range')
      {
        leadItems.push(`${item.lead_range?.min??0}-${item.lead_range?.max??0}`);
      }
      else {
        leadItems.push(`${item.lead_range?.count??0}`);
      }
    });
  }

  const handleSelectedPlan = (price) => {
    if (!price) return;
    const foundDetail =
    paymentDetails?.length &&
    paymentDetails[0]?.payment_options.find((item) => item.price == price.replace("$", ""));
    foundDetail && localStorage.setItem("package_id", foundDetail.id);
    setSelectedPrice(price);
    foundDetail && setSelectedPaymentPlan(foundDetail);
    if (price.replace("$", "") >= 1000) {
      setBonusCredits(true);
    } else {
      setBonusCredits(false);
    }
  };

  const getCreditName = () => {
    const foundDetail =
    paymentDetails?.length &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.price == selectedPrice.replace("$", "")
      );
    return foundDetail?.name || "";
  };

  const getDescription = () => {
    const foundDetail =
    paymentDetails?.length &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.price == selectedPrice.replace("$", "")
      );

    const description = foundDetail?.description;

    let extractedValue;
    let textAfterDollar = "";

    if (description && description?.includes("+")) {
      // Extracting value before '+'
      extractedValue = description?.split("+")[0].trim();
    } else {
      // Extracting all text before '('
      extractedValue = description
        ?.substring(0, description.indexOf("("))
        .trim();
    }

    const dollarIndex = description?.indexOf("$");
    const closingBracketIndex = description?.indexOf(")");
    if (description && dollarIndex !== -1 && closingBracketIndex !== -1) {
      // Extracting text after the dollar sign and before the closing bracket (including both brackets)
      textAfterDollar = `(${description
        ?.substring(dollarIndex, closingBracketIndex + 1)
        .trim()}`;
    }

    return {
      extractedValue: extractedValue || "",
      textAfterDollar: textAfterDollar || "",
    };
  };

  const getBonus = () => {
    const foundDetail =
    paymentDetails?.length  &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.price == selectedPrice.replace("$", "")
      );

    const description = foundDetail?.description;
    let bonus = "";

    const regex = /\+(\d+% bonus)/;
    const match = description?.match(regex);

    // If a match is found, extract the bonus
    if (match && match.length > 0) {
      bonus = match[0];
    }
    return bonus;
  };

  const getTotalCredits = () => {
    const foundDetail =
    paymentDetails?.length &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.price == selectedPrice.replace("$", "")
      );

    const totalCredits = foundDetail?.credits;
    return totalCredits;
  };

  const getPaymentDetails = () => {
    const foundDetail =
    paymentDetails?.length &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.price == selectedPrice.replace("$", "")
      );
      if(foundDetail?.lead_range?.type == 'range')
      {
        return  `${foundDetail?.lead_range?.min??0}-${foundDetail?.lead_range?.max??0}`
      }
      else {
        return `${foundDetail?.lead_range?.count??0} ${""}`
      }
  };
  const getUserSelectedPlan = (packName)=>{
 const foundDetail =
    paymentDetails?.length &&
      selectedPrice &&
      paymentDetails[0]?.payment_options.find(
        (item) => item.name == packName
      );
      if(foundDetail?.lead_range?.type == 'range')
      {
        return  `${foundDetail?.lead_range?.min??0}-${foundDetail.lead_range?.max??0}`
      }
      else {
        return `${foundDetail?.lead_range?.count??0} ${""}`
      }
  }

  const handleServicesTerms = () => {
    window.open("/terms-of-service", "_blank");
  };

  return (
    <>
      <div className="">
        <div className="container">
          <div className="max-w-[630px] w-full mx-auto min-h-[400px] overflow-y-auto">
            <div className="suf-credit overflow-hidden">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-[17px] sm:text-[22px] leading-[160%] font-semibold text-customGray">
                  Modify Plan
                </h3>
                <XMarkIcon
                  className="w-6 h-6 text-customGray cursor-pointer hover:text-red-500"
                  onClick={handleClose}
                />
              </div>
              <p className="text-base font-medium leading-[160%] text-[#485868] mb-3">
                Use the below slider to make changes to your current credit pack
                plan, which automatically renews when your available credit
                balance falls below the threshold for receiving leads. Your next
                billing invoice will reflect this plan change, and record of
                this can be found in your user settings.
              </p>
              <div className="flex gap-1 flex-col md:flex-row mb-2">
                <h3 className="text-sm md:text-base leading-[160%] font-bold text-[#1C1C1C]">
                  Your Current Plan:{" "}
                </h3>
                {professionalInfoDetail?.paymentOption?.name && (
                  <span className="text-sm md:text-base leading-[160%] font-bold text-[#768B9F]">
                    {" "}
                    {professionalInfoDetail?.paymentOption?.name} (
                    {getUserSelectedPlan(professionalInfoDetail?.paymentOption?.name)}
                    leads per billing cycle)
                  </span>
                )}
              </div>
              <div className="flex gap-1  flex-col md:flex-row mb-2">
                <h3 className="text-sm md:text-base leading-[160%] font-bold text-[#1C1C1C]">
                  Your New Plan:{" "}
                </h3>
                <span className="text-sm md:text-base leading-[160%] font-bold text-[#16CA7C]">
                  {" "}
                  {getCreditName()}{" "}
                  {`(${getPaymentDetails()} leads per billing cycle)`}
                </span>
              </div>
              <div className=" mt-[30px] md:mt-[80px]">
                <RangeSlider
                  rangeItems={rangeItems}
                  handleSelectedPlan={handleSelectedPlan}
                  selectedValue={selectedPrice}
                  leadItems={leadItems}
                />
              </div>

              <div className="px-5 py-[14px] rounded-[4px] bg-[#F1F4F6] my-[22px] text-customGray h-full md:h-[66px] flex items-center justify-between flex-col md:flex-row gap-3 md:gap-5">
                <div className="flex items-center gap-[10px]">
                  <h5 className="text-sm md:text-lg font-bold leading-[160%]">
                    {getCreditName()}{" "}
                    <b className="font-black text-customGray">
                      {getTotalCredits() > 100 && (
                        <span
                          className="line-through"
                          style={{
                            textDecorationColor: "#1E90FE",
                            textDecorationThickness: "3px",
                          }}
                        >
                          {parseInt(getDescription().extractedValue)}
                        </span>
                      )}{" "}
                      <span className="text-primary">
                        {getTotalCredits()} {getTotalCredits() && "credits"}
                      </span>
                    </b>
                  </h5>
                  <strong className="text-[#869099]">&#8226;</strong>
                  <span className="text-sm font-medium leading-[160%] text-[#485868]">
                    {getDescription().textAfterDollar}
                  </span>
                </div>
                {bonusCredits && (
                  <div className="py-[10px] md:py-[7px] px-2 rounded-[4px] bg-[#D834A0] max-w-full md:max-w-[135px] w-full">
                    <span className="text-xs font-black leading-[120%] text-white text-center block">
                      {getBonus()} credits <br /> (Total: {getTotalCredits()}{" "}
                      credits)
                    </span>
                  </div>
                )}
              </div>
              <Disclosure as="div" className="faqs-item">
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      as="dt"
                      className="flex w-full items-start justify-between text-left text-gray-900 md:cursor-pointer outline-none focus:bg-transparent pb-4 border-b border-solid border-[#CCD0D4]"
                    >
                      <span className="text-sm font-medium leading-[160%] text-[#485868] flex items-center gap-1">
                        <InformationCircleIcon
                          className="w-6 h-6 text-white fill-primary"
                          aria-hidden="true"
                        />{" "}
                        What are Credits and How Do They Work?
                      </span>
                      <span className="ml-0 md:ml-6 flex h-7 items-center">
                        {open ? (
                          <ChevronUpIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        ) : (
                          <ChevronDownIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        )}
                      </span>
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition transition-[max-height] duration-500 ease-in"
                      enterFrom="transform max-h-0"
                      enterTo="transform max-h-screen"
                      leave="transition transition-[max-height] duration-500 ease-out"
                      leaveFrom="transform max-h-screen"
                      leaveTo="transform max-h-0"
                    >
                      <Disclosure.Panel as="dd" className="mt-5">
                        <p className="text-sm leading-[160%] font-normal text-[#485868]">
                          You are charged “credits” for each client lead you
                          receive, which are deducted from your total credit
                          balance. The cost of credits for each lead is
                          determined by the service the lead is looking for
                          (more specialized services cost more credits). Your
                          total credit balance is automatically topped off to
                          the amount you select above when your credit balance
                          falls below the threshold for receiving leads.
                          Automatic credit renewal can be easily turned off
                          inside your account. Client leads are backed by our
                          Lead Quality Assurance Guarantee and Refund Policy section of
                          our{" "}
                          <span
                            onClick={handleServicesTerms}
                            className="text-primary font-medium cursor-pointer hover:underline"
                          >
                            Terms of Service.
                          </span>
                          {/* <InformationCircleIcon
                          className="h-5 w-5 inline-block mb-[6px] fill-[#869099] text-white"
                          aria-hidden="true"
                        /> */}
                        </p>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditModify;
